'use client'

import { useUserId } from '@repo/cf-user/hooks/use-user-data'
import { useStoreProductHistory } from '../hooks/use-store-product-history'

export const ProductHistoryStore = ({ productId }: { productId?: string }) => {
  const userId = useUserId()
  useStoreProductHistory(userId ?? '', productId)

  return null
}
